// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__Wdzx4","copyright":"Footer_copyright__NWt1M","icon":"Footer_icon__3zRrr","group":"Footer_group__yYg10"};